<div class="remote-control-session-chat-message" *ngIf="isVisible">
  <div class="chat-message">
    <div class="chat-message-text">
      <span [innerHtml]="bubbleStatus | translate:translateParams"></span>
      <button (click)="actionButtonClicked()" [ngClass]="{ 'cancel': isPending, 'join': !isPending }">
        <span>{{ buttonText | translate }}</span>
      </button>
    </div>
  </div>
</div>
